import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { formatDateTime } from "../../lib/format";
import { toast } from "sonner";
import { Sparkle } from "@phosphor-icons/react";

export default function BriefingTab() {
  const [briefing, setBriefing] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    api.get("/ai/briefing/latest").then(r => setBriefing(r.data && r.data.id ? r.data : null));
    // Bootstrap único al montar: api singleton + setter estable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const generate = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/ai/briefing/generate");
      setBriefing(data);
      toast.success("Parte generado");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error");
    } finally { setLoading(false); }
  };
  return (
    <div className="max-w-3xl">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="q-label text-[color:var(--q-muted)]">Parte matutino automático · 07:00 AST</div>
          <h2 className="text-2xl">Resumen ejecutivo</h2>
        </div>
        <button onClick={generate} disabled={loading} data-testid="generate-briefing" className="q-btn-primary flex items-center gap-2">
          <Sparkle size={14} weight="fill"/> {loading ? "Generando…" : "Regenerar"}
        </button>
      </div>
      {briefing ? (
        <div className="q-card p-6">
          <div className="q-label text-[color:var(--q-muted)] mb-2">{formatDateTime(briefing.date)}</div>
          <div className="whitespace-pre-wrap leading-relaxed text-sm" data-testid="briefing-text">{briefing.text}</div>
          <div className="text-[10px] text-[color:var(--q-muted)] mt-4 font-mono">
            ≈US${briefing.est_cost_usd ? briefing.est_cost_usd.toFixed(4) : "0.0000"}
          </div>
        </div>
      ) : (
        <div className="q-card p-6 text-center text-[color:var(--q-muted)]">
          Aún no hay parte generado hoy. Presiona "Regenerar" o espera al cron de las 07:00 AST.
        </div>
      )}
    </div>
  );
}
